<template>
<div class="chapter">
<div class="inner_page">
<p class="image666"><a id="page_ii"></a><a id="page_iii"><span><img alt="Inside the Box: How CrossFit ® Shredded the Rules, Stripped Down the Gym, and Rebuilt My Body, by T.J. Murphy. VeloPress Books." src="images/title.jpg"/></span></a></p><a id="page_iii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?6ee1f0da